import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations/reservationQuestions";
import ReservationAnswer from "./ReservationAnswer";

export default function ReservationQuestionAnswers({ reservation, handleEmpty }) {
  const [reservationQuestions, setReservationQuestions] = useState([]);

  useEffect(() => {
    index(reservation.id, (response) => {
      setReservationQuestions(response);
      if(response.length === 0 && handleEmpty) {
        handleEmpty();
      }
    });
  }, [reservation.reservation_items?.length]);

  if(!reservationQuestions || reservationQuestions.length === 0) return(
    <Stack>
      <Typography variant="body1">There are no additional questions for this booking!</Typography>
    </Stack>
  );

  return (
    <Stack>
      <Stack spacing={2}>
        {reservationQuestions?.map((question) => (
          <Stack key={`${reservation.id}-${question.id}`}>
            <Stack>
              <Typography variant="body1"><i>{question.question}</i></Typography>
            </Stack>
            <Stack>
              <ReservationAnswer reservation={reservation} question={question} />
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}